import AbstractHtmlConstructorType
    from "~/cabinet/vue/interface/htmlConstructor/constructorType/AbstractHtmlConstructorType";
import OnlineChatHtmlContentDisplay
    from "~/cabinet/vue/interface/htmlConstructor/constructorType/onlineChatHtml/OnlineChatHtmlContentDisplay.vue";
import {IHtmlConstructorBlock} from "~/cabinet/vue/interface/htmlConstructor/Interface";
import {HTML_BLOCK_TYPE_TEXT} from "~/cabinet/vue/interface/htmlConstructor/blocks/Constants";
import {RawComponent, useRawComponent} from "~/core-ui/ts/useRawComponent";

export default class OnlineChatHtmlConstructorType extends AbstractHtmlConstructorType {
    get contentDisplayComponent(): RawComponent {
        return useRawComponent(OnlineChatHtmlContentDisplay);
    }

    getDefaultBlockLists(): IHtmlConstructorBlock<any>[] {
        return [
            {
                type: HTML_BLOCK_TYPE_TEXT,
                values: {}
            }
        ];
    }
}